module.exports = __webpack_public_path__ + "media/components/shared/pdf_icon-a529924551e29891c0be2cd368966f3a.jpg";